import vFlow from "./v-flow.vue";
import vFlowStep from "./v-flow-step.vue";

export default Vue => {
  Vue.component("v-flow", vFlow);
  Vue.component("v-flow-step", vFlowStep);
};
